import { useNavigate } from 'react-router-dom';
import Image from '../../../components/AppImage';
import { formatDateYYYYMMDD } from '../../../utils/numbers';
import { ContentBlocks } from '../../../components/ContentBlockRenderer';

const DiscussionHeader = ({ discussion }) => {
  const navigate = useNavigate();
  return (
    <div className="mb-12 text-center">
      {/* Tag */}
      <div className="flex items-center justify-center mb-6">
        <span
          className="px-4 py-2 rounded-full border border-[#C5A059] bg-transparent text-[#C5A059] text-sm"
          style={{ fontFamily: 'Amiri, serif' }}
        >
          {discussion?.tagAr} / {discussion?.tag}
        </span>
      </div>

      {/* Title */}
      <h1
        className="text-[40px] mb-6 leading-tight"
        style={{
          fontFamily: 'Amiri, serif',
          color: '#2C2B29',
          fontWeight: 700
        }}
      >
        {discussion?.title}
      </h1>

      {/* Context / Body content */}
      {discussion?.content?.length > 0 && (
        <div
          className="text-[20px] mb-8 leading-relaxed text-right"
          style={{
            fontFamily: 'Amiri, serif',
            color: '#999',
            lineHeight: '1.8'
          }}
        >
          <ContentBlocks content={discussion.content} />
        </div>
      )}

      {/* Initiator */}
      <div className="flex items-center justify-center gap-3">
        <Image
          src={discussion?.initiator?.avatar}
          alt={discussion?.initiator?.avatarAlt}
          className="w-10 h-10 rounded-full object-cover shadow-warm cursor-pointer"
          type="user"
          onClick={() => discussion?.initiator?.id && navigate(`/user/${discussion.initiator.id}`)}
        />
        <span className="text-sm" style={{ fontFamily: 'Amiri, serif', color: '#999' }}>
          بدأها{' '}
          <span
            className="cursor-pointer hover:text-[#C5A059] transition-colors"
            onClick={() => discussion?.initiator?.id && navigate(`/user/${discussion.initiator.id}`)}
          >
            {discussion?.initiator?.name}
          </span>
          {' '}• <span dir="ltr">{formatDateYYYYMMDD(discussion?.startedDate ?? '')}</span>
        </span>
      </div>

      {/* Divider */}
      <div className="w-full h-[1px] bg-[rgba(197,160,89,0.2)] mt-12" />
    </div>
  );
};

export default DiscussionHeader;